import React, {useEffect, useState} from 'react';
import Metadata from "../Metadata";
import PageNavigation from "../../../../components/ocr-batch/PageNavigation";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {OcrMode, OcrResultPage} from "../../../../models/ocr.models";
import {ResultsSection, ResultText} from "./ResultPanel.styled";
import {useTranslation} from "react-i18next";

interface ResultPanelProps {
    pages: OcrResultPage[];
    mode: OcrMode;
}

const ResultPanel = ({
    pages,
    mode,
}: ResultPanelProps) => {
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const parsedPages = pages.map(page => page.text) || [];

    // reset strony gdy zmienia się wynik
    useEffect(() => {
        setCurrentPage(1);
    }, [pages]);

    return (
        <>
            {pages.length > 0 ? (
                <ResultsSection as="section" aria-label={t('ocr.aria.resultsSection')}>
                    <Metadata pagesLength={parsedPages.length} mode={mode} />

                    {parsedPages.length > 1 && (
                        <PageNavigation currentPage={currentPage}
                                        totalPages={parsedPages.length}
                                        setCurrentPage={setCurrentPage} />
                    )}

                    <ResultText role="region" aria-label={t('ocr.page.info', {current: currentPage, total: parsedPages.length})}>
                        {mode === 'PLAIN_OCR' ? (
                            parsedPages[currentPage - 1]
                        ) : (
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {parsedPages[currentPage - 1]}
                            </ReactMarkdown>
                        )}
                    </ResultText>
                </ResultsSection>
            ) : (
                <ResultText aria-live="polite" aria-label={t('ocr.result.resultsNoResult')}>
                    {t('ocr.result.resultsNoResult')}
                </ResultText>
            )}
        </>
    );
}

export default ResultPanel;